import { AssistantPanelView } from "./Layout/types";

export const ASSISTANT_PANEL_DEFAULT_VIEW = AssistantPanelView.CHAT;

export const ASSISTANT_PAGE_PATH = "/assistant";
